import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchTimelineEventsForEndUser = createAction(constants.FETCH_TIMELINE_EVENTS_FOR_END_USER)
export const fetchTimelineEventsForEndUserPending = createAction(constants.FETCH_TIMELINE_EVENTS_FOR_END_USER_PENDING)
export const fetchTimelineEventsForEndUserCancelled = createAction(constants.FETCH_TIMELINE_EVENTS_FOR_END_USER_CANCELLED)
export const fetchTimelineEventsForEndUserFailed = createAction(constants.FETCH_TIMELINE_EVENTS_FOR_END_USER_FAILED)
export const fetchTimelineEventsForEndUserSuccess = createAction(constants.FETCH_TIMELINE_EVENTS_FOR_END_USER_SUCCESS)

export const loadMoreTimelineEventsForEndUser = createAction(constants.LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER)
export const loadMoreTimelineEventsForEndUserPending = createAction(constants.LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_PENDING)
export const loadMoreTimelineEventsForEndUserCancelled = createAction(constants.LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_CANCELLED)
export const loadMoreTimelineEventsForEndUserFailed = createAction(constants.LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_FAILED)
export const loadMoreTimelineEventsForEndUserSuccess = createAction(constants.LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_SUCCESS)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/timeline/actions.js